import { Avatar, Container, Link, Stack } from '@mui/material';
import { getBurgerMenuItems } from 'API/Home/burgerMenuItems';
import { BurgerMenu } from 'Components/BurgerMenu';
import { Footer2 } from 'Components/Footer2';
import { Header2 } from 'Components/Header2';
import { PublicHeader } from 'Components/PublicHeader';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDispatchApp, useIsDesktop } from 'Hooks';
import { useFocusFirstPossibleElement } from 'Hooks/useFocusFirstPossibleElement';
import { SuppliersBGDesk, SuppliersBGMobile } from 'Images';
import { setMenuItems } from 'Store/MenuItemsSlice';
import { useCallback, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

export const SuppliersLayout = () => {
  const isDesktop = useIsDesktop();

  const { authenticatedUser, fakeUser } = useAppSelector(
    ({ imposter }) => imposter
  );

  const mainContent = useRef<HTMLDivElement | null>(null);

  const isUser = fakeUser?.israeliId || authenticatedUser?.israeliId;

  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );

  const dispatch = useDispatchApp();

  const initMenuItems = useCallback(async () => {
    if (burgerMenuItems.length === 0 && isUser) {
      const menuItemsResult = await getBurgerMenuItems();
      dispatch(setMenuItems(menuItemsResult));
    }
  }, [burgerMenuItems.length, isUser, dispatch]);

  useEffect(() => {
    initMenuItems();
  }, [initMenuItems]);

  useFocusFirstPossibleElement(mainContent.current);

  return (
    <>
      <Link className='sr-only' href={'#main-content'}>
        {Dictionary[DICTIONARY.General].skipToSiteContent}
      </Link>
      <Link className='sr-only' href={'#main-content'}>
        {Dictionary[DICTIONARY.General].skipToSiteContent}
      </Link>
      {isUser ? (
        <Header2 />
      ) : (
        <PublicHeader style={{ fontFamily: 'Assistant' }} />
      )}

      <Stack bgcolor={isDesktop ? 'primary.shade_50' : undefined}>
        <Avatar
          alt=''
          src={isDesktop ? SuppliersBGDesk : SuppliersBGMobile}
          sx={{
            width: '100%',
            height: isDesktop ? '388px' : '240px',
            position: 'absolute',
            top: '72px',
            left: 0,
            right: 0,
          }}
        />
        <Container component={'main'}>
          <Stack
            direction={'row'}
            sx={{
              minHeight: 'calc(100vh - 72px - 100px)',
            }}
            ref={mainContent}
          >
            {isUser && <BurgerMenu />}
            <Stack
              paddingTop={{ sm: '28px', xs: '20px' }}
              paddingBottom={{ sm: '80px', xs: '65px' }}
              paddingLeft={{ lg: '275px', sm: '24px', xs: '0px' }}
              paddingRight={{ sm: '275px', xs: '0px' }}
              id='main-content'
              tabIndex={-1}
            >
              <Outlet />
            </Stack>
          </Stack>
        </Container>
      </Stack>
      <Footer2 />
    </>
  );
};
